/**
 * AVISOS DEL CHAT ELITE (sonido) coordinados entre pestañas.
 *
 * Si el usuario tiene varias pestañas abiertas, un mismo mensaje solo debe sonar una vez.
 * La pestaña visible reclama el aviso al momento; las ocultas esperan un poco y solo suenan
 * si ninguna otra lo ha reclamado antes (marca en localStorage, compartido entre pestañas).
 */

const SONIDO = "/assets/sonidos/message_notification_sound.mp3";
const PREFIJO = "chatElite:aviso:";
const ESPERA_OCULTA_MS = 350;
const CADUCIDAD_MS = 60 * 1000;

let audio = null;

const reproducir = () => {
  try {
    if (!audio && typeof Audio !== "undefined") {
      audio = new Audio(SONIDO);
      audio.preload = "auto";
    }
    if (!audio) return;
    audio.currentTime = 0;
    const promesa = audio.play();
    if (promesa?.catch) promesa.catch(() => {}); // el navegador puede bloquearlo sin interaccion previa
  } catch (_) {}
};

const reclamar = (clave) => {
  try {
    const k = PREFIJO + clave;
    const previo = Number(localStorage.getItem(k));
    if (previo && Date.now() - previo < CADUCIDAD_MS) return false;
    localStorage.setItem(k, String(Date.now()));
    return true;
  } catch (_) {
    return true; // sin localStorage (modo privado): suena en esta pestaña
  }
};

// Limpia marcas antiguas para no llenar localStorage
const limpiarMarcas = () => {
  try {
    const ahora = Date.now();
    Object.keys(localStorage)
      .filter((k) => k.startsWith(PREFIJO))
      .forEach((k) => {
        if (ahora - Number(localStorage.getItem(k)) > CADUCIDAD_MS) localStorage.removeItem(k);
      });
  } catch (_) {}
};

/**
 * Reproduce el sonido de aviso una sola vez por `clave` entre todas las pestañas del navegador.
 * @param {string|number} clave - p.ej. el id del mensaje
 */
export const avisarUnaVez = (clave) => {
  const visible = typeof document === "undefined" || document.visibilityState === "visible";
  const intentar = () => {
    if (reclamar(clave)) reproducir();
    limpiarMarcas();
  };
  if (visible) intentar();
  else setTimeout(intentar, ESPERA_OCULTA_MS);
};
